function setCookie(cName, cValue, expDays) {
  let date = new Date();
  date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

function getCookie(name) {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

async function checkUrlAndSetOrganization() {
  const paramsString = window.location.search;
  const searchParams = new URLSearchParams(paramsString);

  for (const p of searchParams) {
    if (p[0] === "orgId") {
      const org = orgs.find((c) => c.id === Number(p[1]));
      // document.getElementById('organization-selector').value = Number(p[1]);
      document.getElementById("orgModal").style.display = "block";
      document.getElementById("org-assigned-name").innerText = org.name;
      document.getElementById("org-assigned-logo-url").src = org.logoUrl;
      document.getElementById("contact-phone").innerText =
        document.getElementById("contact-phone").innerText + " " + org.phone;
      document.getElementById("contact-address").innerText =
        document.getElementById("contact-address").innerText +
        " " +
        org.address.street +
        " " +
        org.address.city +
        ", " +
        org.address.state +
        " " +
        org.address.zip;

      const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
      const cartJSON = await cartResponse.json();

      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            organizationId: org.id,
            organzationName: org.name,
            donationAmount: (
              (cartJSON.items_subtotal_price * 0.1) /
              100
            ).toFixed(2),
          },
        }),
      });

      setCookie("selectedOrganization", JSON.stringify(org), 180);
      if (document.getElementById("donation-total-org-name") && org) {
        console.log(
          document.getElementById("donation-total-org-name").innerText
        );
        document.getElementById("donation-total-org-name").innerText =
          org.name + " " + "will recieve:";
      }
    }
  }
}

async function setSelectedOrganizationIfCookiePreset() {
  if (getCookie("selectedOrganization")) {
    const selectedOrg = JSON.parse(getCookie("selectedOrganization"));

    const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
    const cartJSON = await cartResponse.json();

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          organizationId: org.id,
          organzationName: org.name,
          donationAmount: ((cartJSON.items_subtotal_price * 0.1) / 100).toFixed(
            2
          ),
        },
      }),
    });

    if (document.getElementById("organization-selector")) {
      document.getElementById("organization-selector").value = selectedOrg.id;
    }
  }
}

checkUrlAndSetOrganization();
setSelectedOrganizationIfCookiePreset();

document.getElementById("modal-close").addEventListener("click", () => {
  document.getElementById("orgModal").style.display = "none";
});
